import { useEffect, useState, memo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import "../styles/CategorySlide.css";
import { getcategorybanner } from "../services/categorybanner.service";
import { Link } from "react-router-dom";
// import shpopingbag from "../../../assets/icons/shopingbags.svg";

function CategorySlider() {
  const [categories, setCategories] = useState([]);
  const [offers, setOffers] = useState(null);
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await getcategorybanner(); // Call your API service here
        if (data) {
          // Set categories data
          const categoryData = data.categories.map(item => ({
            name: item.name,
            type: item.short_video ? "video" : "image",
            src: item.short_video || item.media,
            actionLink: item.actionLink,
          }));
          setCategories(categoryData);

          // Set offers data
          setOffers(data.offers);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []); 

   if (categories.length === 0 && !offers) {
    return null;
  }

  return (
    <div className="category-slider">
      <Swiper
        modules={[FreeMode]}
        spaceBetween={5}
        slidesPerView={6}
        freeMode={true}
        grabCursor={true}
        speed={200}
        breakpoints={{
          320: { slidesPerView: 4.3 },
          480: { slidesPerView: 4.3 },
          768: { slidesPerView: 5 },
          1024: { slidesPerView: 8 },
        }}
      >
        {/* Display offer as a category item */}
        {offers && (
          <SwiperSlide key="offer">
            <div className="category-item offer-item">
              <div className="circle-box">
                <div className="circle offer-circle">
                  <div className="sale-only">
                    <a
                      href={offers.actionLink}
                      className="offer-link"
                      style={{ textDecoration: "none", color: "#FFF", fontWeight: "600" }}
                     >
                       <i class="bi bi-bag" style={{ color:"#d71212"}}></i>
                        {/* {offers.name} */}
                    </a>
                  </div>
                </div>
              </div>
              <p style={{ fontWeight: "bold" }}>
                <Link to={offers.actionLink} target="_blank" style={{color:"#000", textDecoration:"none"}}> 
                  {offers.heading}
                </Link>
                </p>
            </div>
          </SwiperSlide>
        )}

        {/* Loop through categories */}
        
        {categories.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="category-item">
              <div className="circle-box">
               <div className="circle">
                  <Link to={item.actionLink} target="_blank">
                    {item.type === "image" && (
                      <img src={item.src} alt={item.name} loading="lazy" />
                    )}

                    {item.type === "video" && item.src && (
                      <video src={item.src} muted autoPlay loop playsInline />
                    )}

                  </Link>
                </div>
              </div>
              <p>
                <Link to={item.actionLink} target="_blank" style={{color:"#000", textDecoration:"none"}}> 
                {item.name}
                </Link> 
                </p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
export default memo(CategorySlider);